<ng-container
  *ngIf="{
    contentInfo: contentInfo$ | async,
    chatRating: chatRating$ | async
  } as data"
>
  <h2 class="title">
    {{ data.contentInfo.unlockedContentCount }} /
    {{ data.contentInfo.totalContentCount }} unlocked
  </h2>

  <div class="photos-wrapper">
    <div #scrollContainer class="scroll-container">
      <div class="photos-grid">
        @for (item of data.contentInfo.contents; track $index) {
          <div [id]="'photo-' + item.index" class="photo-card">
            @if (item.url) {
              <img
                [src]="item.url"
                alt=""
                class="photo"
                draggable="false"
                (click)="openFullscreen($index)"
              />
            } @else {
              <div class="locked">
                <img
                  src="/assets/img/profile-page/album/lock.png"
                  alt=""
                  class="locked-icon"
                />

                <div class="rating">
                  {{ data.chatRating }}/{{ item.ratingRequired }}

                  <img
                    src="/assets/img/chat-page/rating-bar/ai/heart-sexting.svg"
                    alt=""
                  />
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <app-button class="close-btn" (click)="close()">Close</app-button>
</ng-container>
